import { Duration } from 'luxon';

type Unit = 'seconds' | 'minutes' | 'hours' | 'days' | 'months' | 'years';

function hasWholeValue(v: number): boolean {
    return Math.floor(Math.abs(v)) !== 0;
}

export default function selectValueAndUnit(d: Duration): [number, Unit] {
    const years = d.as('years');
    const months = d.as('months');
    const days = d.as('days');
    const hours = d.as('hours');
    const minutes = d.as('minutes');
    const seconds = d.as('seconds');

    if (hasWholeValue(years)) {
        return [years, 'years'];
    }

    if (hasWholeValue(months)) {
        return [months, 'months'];
    }

    if (hasWholeValue(days)) {
        return [days, 'days'];
    }

    if (hasWholeValue(hours)) {
        return [hours, 'hours'];
    }

    if (hasWholeValue(minutes)) {
        return [minutes, 'minutes'];
    }

    return [seconds, 'seconds'];
}
